<template>
  <v-simple-table>
    <template v-slot:default>
      <tbody>
        <tr v-for="(item, j) in fichaContenido(grupo)" :key="j">
          <td class="caption font-weight-bold">
            {{ item.Descripcion }}
          </td>
          <td
            class="font-weight-bold caption text-right"
            v-html="item.Valor"
          ></td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "EspecificacionesItem",
  props: {
    grupo: Number,
  },
  computed: {
    ...mapState(["EspecifTecnica"]),
    fichaContenido: function () {
      return function (id) {
        return this.EspecifTecnica.filter(
          (x) => x.Grupo === id && x.Valor != ""
        );
      };
    },
  },
};
</script>

<style></style>
